import { useMutation } from "react-query";
import getBulkDisbursementSummary from "../services/getBulkDisbursementSummary";

function useGetBulkDisbursementSummary() {
  return useMutation(["bulk-disbursement-summary"], getBulkDisbursementSummary);
}

export default useGetBulkDisbursementSummary;
